module.exports = __webpack_public_path__ + "static/img/chery_4@2x.f857ac5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/chery_4@2x.png
// module id = dGD2
// module chunks = 0